module.exports = __webpack_public_path__ + "static/media/punk_male-transparent.8c3b3102.png";